import React from 'react';
import { Popover } from '@headlessui/react';
import { createTagLink } from './createBlogTagLink';
import Link from 'next/link';

const TopicsPopup: React.FC = () => {
  return (
    <Popover.Panel className="absolute z-50 transform -translate-x-1/2">
      {({ close }) => (
        <div className="absolute z-40 bg-white border w-44 -left-13 md:left-3 top-6 lg:top-7 border-gray ">
          <div className="relative">
            <div className="absolute w-3 h-3 bg-white -top-1.7 right-6 md:left-16 border-t border-l border-gray transform rotate-45" />
            <div className="flex flex-col py-2 text-16-26-0.3 border-gray">
              <Link
                className="px-3 py-1 cursor-pointer hover:text-gold-hover"
                href={createTagLink('real-estate-news')}
                onClick={() => close()}
              >
                Real Estate News
              </Link>
              <Link
                className="px-3 py-1 cursor-pointer hover:text-gold-hover"
                href={createTagLink('opinions-and-advice')}
                onClick={() => close()}
              >
                Opinions &amp; Advice
              </Link>
              <Link
                className="px-3 py-1 cursor-pointer hover:text-gold-hover"
                href={createTagLink('lifestyle')}
                onClick={() => close()}
              >
                Lifestyle
              </Link>
              <Link
                className="px-3 py-1 cursor-pointer hover:text-gold-hover"
                href={createTagLink('market-reports')}
                onClick={() => close()}
              >
                Market Reports
              </Link>
            </div>
          </div>
        </div>
      )}
    </Popover.Panel>
  );
};

export default TopicsPopup;
